// Unique data for each service page

export const servicePageData = {
  'trademark-registration': {
    hero: {
      title: 'Trademark Registration Services',
      description: 'Protect your brand identity with our comprehensive trademark registration services. Starting at just $45, we make brand protection accessible, efficient, and hassle-free for businesses of all sizes.',
      badge: 'Trusted Brand Protection',
      image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/8twkxvnc_img-1.jpg'
    },
    process: [
      {
        step: 1,
        title: 'Submit Your Details',
        description: 'Fill out our simple form with your brand information and trademark details.'
      },
      {
        step: 2,
        title: 'We Review & Search',
        description: 'Our experts conduct a thorough search and review your application for conflicts.'
      },
      {
        step: 3,
        title: 'File & Protect',
        description: 'We file your trademark with USPTO and monitor the process until registration.'
      }
    ],
    benefits: [
      {
        title: 'Legal Protection',
        description: 'Gain exclusive legal rights to your brand identity nationwide and prevent unauthorized use.'
      },
      {
        title: 'Brand Recognition',
        description: 'Build customer trust and establish your brand as a credible, professional entity.'
      },
      {
        title: 'Competitive Edge',
        description: 'Stand out in the marketplace and prevent competitors from using similar marks.'
      },
      {
        title: 'Asset Value',
        description: 'Your trademark becomes a valuable business asset that can appreciate over time.'
      },
      {
        title: 'Legal Recourse',
        description: 'Take legal action against infringers and protect your brand investment.'
      },
      {
        title: 'Nationwide Rights',
        description: 'Secure protection across all 50 states with potential for global expansion.'
      }
    ],
    pricing: [
      {
        id: 'basic',
        name: 'Basic',
        price: 45,
        popular: false,
        features: [
          { name: 'Case Review', included: true },
          { name: 'Case Filing', included: true },
          { name: 'Basic Search', included: true },
          { name: 'State E-Filing', included: true },
          { name: 'Trademark Secured', included: true }
        ]
      },
      {
        id: 'deluxe',
        name: 'Deluxe',
        price: 145,
        popular: true,
        features: [
          { name: 'Case Review', included: true },
          { name: 'Case Filing', included: true },
          { name: 'Basic Search', included: true },
          { name: 'State E-Filing', included: true },
          { name: 'Trademark Secured', included: true },
          { name: 'Direct Hit Search', included: true },
          { name: 'Dedicated Case Manager', included: true }
        ]
      },
      {
        id: 'premium',
        name: 'Premium',
        price: 299,
        popular: false,
        features: [
          { name: 'Case Review (by a TM Expert)', included: true },
          { name: 'Basic Free Trademark Search', included: true },
          { name: 'Trademark Monitoring Services (3 Months)', included: true },
          { name: 'Trademark Secured', included: true },
          { name: 'Refusal Risk Meter', included: true },
          { name: 'Case filing service with complete paperwork', included: true }
        ]
      },
      {
        id: 'elite',
        name: 'Elite',
        price: 599,
        popular: false,
        features: [
          { name: 'Case Review & Filing (U.S Registered IP Attorney)', included: true },
          { name: 'Assigned Case Filing Officer', included: true },
          { name: 'Private Registration', included: true },
          { name: 'Trademark Secured', included: true },
          { name: 'Federal Search & Clearance Report (All States)', included: true },
          { name: 'Federal E-Filing (USPTO)', included: true },
          { name: 'Cease & Desist Letter', included: true },
          { name: 'Same Day Filing', included: true },
          { name: 'Trademark Monitoring (1 Year)', included: true },
          { name: 'Direct Hit Search', included: true },
          { name: 'Dedicated Case Manager', included: true },
          { name: '24/7 Secure Online Access', included: true },
          { name: '100% Approval Guarantee', included: true }
        ]
      }
    ],
    keyBenefits: [
      'Comprehensive trademark search to avoid conflicts',
      'Professional application preparation by experts',
      'USPTO filing and monitoring throughout the process',
      'Affordable pricing starting at just $45',
      'Fast turnaround with 24-hour processing available',
      '100% satisfaction guarantee on all services'
    ],
    faqs: [
      {
        id: 1,
        question: 'How long does trademark registration take?',
        answer: 'The trademark registration process typically takes 8-12 months from filing to approval.'
      },
      {
        id: 2,
        question: 'What can be trademarked?',
        answer: 'You can trademark names, logos, slogans, and other brand identifiers that distinguish your goods or services.'
      },
      {
        id: 3,
        question: 'Do I need a lawyer to register a trademark?',
        answer: 'While not required, professional assistance increases approval rates and ensures proper filing.'
      },
      {
        id: 4,
        question: 'What is the government filing fee?',
        answer: 'USPTO filing fees range from $250-$350 per class, separate from our service fees.'
      },
      {
        id: 5,
        question: 'Can my trademark be rejected?',
        answer: 'Yes, but our thorough search and expert preparation minimize rejection risks significantly.'
      }
    ]
  },
  
  'copyright-registration': {
    hero: {
      title: 'Copyright Registration Services',
      description: 'Protect your original creative works with professional copyright registration. From literary works to digital content, we safeguard your intellectual property rights.',
      badge: 'Creative Work Protection',
      image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/7in8sg48_img-1.jpg'
    },
    process: [
      {
        step: 1,
        title: 'Submit Your Work',
        description: 'Provide details about your creative work and upload any necessary files.'
      },
      {
        step: 2,
        title: 'We Prepare & Review',
        description: 'Our team prepares your copyright application and reviews it for accuracy.'
      },
      {
        step: 3,
        title: 'File & Certify',
        description: 'We file with the Copyright Office and you receive your certificate.'
      }
    ],
    benefits: [
      {
        title: 'Legal Proof',
        description: 'Establishes public record of your copyright ownership'
      },
      {
        title: 'Exclusive Rights',
        description: 'Control reproduction and distribution of your work'
      },
      {
        title: 'Prevent Theft',
        description: 'Take legal action against unauthorized use'
      },
      {
        title: 'Statutory Damages',
        description: 'Eligible for statutory damages in infringement cases'
      },
      {
        title: 'Business Asset',
        description: 'Your copyright becomes a valuable property asset'
      },
      {
        title: 'Licensing Rights',
        description: 'License your work to others for profit'
      }
    ],
    pricing: [
      {
        id: 'gold',
        name: 'Gold',
        price: 99,
        popular: false,
        features: [
          { name: 'Professional Preparation of federal copyright application', included: true },
          { name: 'Review by copyright team for accuracy', included: true },
          { name: 'Federal E-Filing with USPTO', included: true },
          { name: 'Certificate of Registration mailed to you', included: true }
        ]
      },
      {
        id: 'diamond',
        name: 'Diamond',
        price: 149,
        popular: true,
        features: [
          { name: 'Everything in Gold package', included: true },
          { name: 'Cease & Desist Letter template', included: true },
          { name: 'Transfer/Assignment template', included: true },
          { name: '24 Hours Expedited Processing', included: true },
          { name: 'Priority review and filing', included: true }
        ]
      }
    ],
    keyBenefits: [
      'Professional application preparation by copyright specialists',
      'Comprehensive review for accuracy and completeness',
      'Electronic filing for faster processing',
      'Cease and desist letter templates included',
      '24-hour expedited service option',
      'Certificate of registration delivered to you'
    ],
    faqs: [
      {
        id: 1,
        question: 'What can be copyrighted?',
        answer: 'Original works of authorship including literary, musical, dramatic, artistic, and certain other intellectual works.'
      },
      {
        id: 2,
        question: 'How long does copyright last?',
        answer: 'Generally, copyright lasts for the life of the author plus 70 years.'
      },
      {
        id: 3,
        question: 'Do I need to register my copyright?',
        answer: 'Registration is not required but provides important legal benefits and protections.'
      },
      {
        id: 4,
        question: 'What is the filing fee?',
        answer: 'USPTO filing fees are included in our package pricing.'
      },
      {
        id: 5,
        question: 'How long does registration take?',
        answer: 'Standard processing takes 3-6 months; expedited service available in 24 hours.'
      }
    ]
  },
  
  'company-formation': {
    hero: {
      title: 'Business Formation Services',
      description: 'Start your business the right way with professional business formation services. From LLCs to corporations, we handle all the paperwork and compliance requirements so you can focus on building your dream business.',
      badge: 'Business Setup Experts',
      image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/twa7ph1b_img-1.jpg'
    },
    process: [
      {
        step: 1,
        title: 'Choose Your Structure',
        description: 'Select the business entity type that best fits your needs - LLC, S-Corp, or C-Corp.'
      },
      {
        step: 2,
        title: 'Submit Your Information',
        description: 'Provide your business details through our simple online form. We handle all the paperwork.'
      },
      {
        step: 3,
        title: 'Get Legally Established',
        description: 'We file with the state, obtain your EIN, and deliver all formation documents to you.'
      }
    ],
    benefits: [
      {
        title: 'Personal Asset Protection',
        description: 'Protect your personal assets from business liabilities with proper entity formation.'
      },
      {
        title: 'Tax Advantages',
        description: 'Choose the right structure to optimize your tax situation and save money.'
      },
      {
        title: 'Professional Credibility',
        description: 'Establish your business as a legitimate, professional entity that customers trust.'
      },
      {
        title: 'Legal Compliance',
        description: 'Ensure your business is properly registered and compliant with all state requirements.'
      },
      {
        title: 'Easier Financing',
        description: 'Properly formed businesses have better access to loans, credit, and investment capital.'
      },
      {
        title: 'Business Growth',
        description: 'Set up the right foundation for scaling your business and adding partners or investors.'
      }
    ],
    pricing: [],
    customPricing: {
      title: 'Custom Company Formation Packages for Every Business',
      description: 'Filing Protection offers a range of tailored packages designed for businesses of all sizes. Our affordable, all-inclusive options provide the support you need at every step of your company formation process.',
      features: [
        'Make sure you\'re not liable for any business debts',
        'Company Formation through a Simple Process',
        'Save Money on Taxes'
      ]
    },
    keyBenefits: [
      'Complete business name availability check',
      'Preparation and filing of all formation documents',
      'EIN (Employer Identification Number) registration',
      'Registered Agent service for one year',
      'Operating Agreement or Corporate Bylaws',
      'Ongoing compliance guidance and support'
    ],
    faqs: [
      {
        id: 1,
        question: 'What type of business structure should I choose?',
        answer: 'It depends on your needs. LLCs offer flexibility, S-Corps provide tax benefits, and C-Corps are best for larger companies seeking investment.'
      },
      {
        id: 2,
        question: 'How long does business formation take?',
        answer: 'Most formations are completed within 5-10 business days, depending on the state.'
      },
      {
        id: 3,
        question: 'What is an EIN and do I need one?',
        answer: 'An EIN (Employer Identification Number) is like a social security number for your business. Most businesses need one.'
      },
      {
        id: 4,
        question: 'What is a Registered Agent?',
        answer: 'A registered agent receives legal documents on behalf of your business. We provide this service for one year.'
      },
      {
        id: 5,
        question: 'Do you handle state filing fees?',
        answer: 'State filing fees vary by state and are additional to our service fees.'
      }
    ]
  },
  
  'trademark-search': {
    hero: {
      title: 'Comprehensive Trademark Search Services',
      description: 'Protect your brand investment with a thorough trademark search. Identify potential conflicts before filing and increase your chances of successful registration with our professional search services starting at just $149.',
      badge: 'Conflict Prevention',
      image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/e9rvmuhj_img-1.jpg'
    },
    process: [
      {
        step: 1,
        title: 'Submit Your Request',
        description: 'Provide your trademark details through our simple online form. Tell us about your mark.'
      },
      {
        step: 2,
        title: 'We Conduct Research',
        description: 'Our experts perform comprehensive searches across multiple databases to identify conflicts.'
      },
      {
        step: 3,
        title: 'Receive Detailed Report',
        description: 'Get a detailed analysis report with findings, risk assessment, and expert recommendations.'
      }
    ],
    benefits: [
      {
        title: 'Avoid Rejection',
        description: 'Identify conflicting marks before filing to avoid costly USPTO rejections and wasted fees.'
      },
      {
        title: 'Save Time & Money',
        description: 'Prevent expensive rebranding and legal disputes by finding conflicts early in the process.'
      },
      {
        title: 'Legal Protection',
        description: 'Ensure you\'re not infringing on existing trademarks and avoid potential lawsuits.'
      },
      {
        title: 'Strategic Advantage',
        description: 'Make informed decisions about your trademark strategy with comprehensive market intelligence.'
      },
      {
        title: 'Clear Path Forward',
        description: 'Get expert recommendations on how to proceed with confidence in your trademark application.'
      },
      {
        title: 'Peace of Mind',
        description: 'File your trademark application knowing you\'ve done thorough due diligence.'
      }
    ],
    pricing: [
      {
        id: 'federal-state',
        name: 'Federal & State Search',
        price: 149,
        popular: false,
        features: [
          { name: 'Federal trademark search (USPTO database)', included: true },
          { name: 'All 50 states trademark search', included: true },
          { name: 'Detailed online report', included: true },
          { name: 'Conflict identification', included: true },
          { name: 'Risk assessment', included: true },
          { name: 'Email support', included: true }
        ]
      },
      {
        id: 'comprehensive',
        name: 'Comprehensive Search',
        price: 299,
        popular: true,
        features: [
          { name: 'Everything in Federal & State Search', included: true },
          { name: 'Common law trademark search', included: true },
          { name: 'Corporate name search (all 50 states)', included: true },
          { name: 'Corporate directories search', included: true },
          { name: 'Internet & domain name search', included: true },
          { name: 'Detailed analysis report', included: true },
          { name: 'Expert recommendations', included: true },
          { name: 'Priority support', included: true }
        ]
      },
      {
        id: 'global',
        name: 'Global Search',
        price: 499,
        popular: false,
        features: [
          { name: 'Everything in Comprehensive Search', included: true },
          { name: 'European Community trademark search', included: true },
          { name: 'WIPO international trademark search', included: true },
          { name: 'Major international jurisdictions', included: true },
          { name: 'Multi-national conflict analysis', included: true },
          { name: 'Global protection strategy', included: true },
          { name: 'Expert consultation (30 min)', included: true },
          { name: '24/7 priority support', included: true }
        ]
      }
    ],
    keyBenefits: [
      'USPTO federal trademark database search',
      'All 50 states trademark registrations',
      'Common law trademark research',
      'Domain name availability check',
      'Corporate name database search',
      'Detailed risk assessment and recommendations'
    ],
    faqs: [
      {
        id: 1,
        question: 'Why do I need a trademark search?',
        answer: 'A search identifies existing similar marks that could cause your application to be rejected or lead to legal disputes.'
      },
      {
        id: 2,
        question: 'What does a trademark search include?',
        answer: 'Federal, state, and common law searches across multiple databases to identify potential conflicts.'
      },
      {
        id: 3,
        question: 'How long does a trademark search take?',
        answer: 'Most searches are completed within 2-3 business days.'
      },
      {
        id: 4,
        question: 'What if conflicts are found?',
        answer: 'We provide expert recommendations on how to proceed, including modification suggestions.'
      },
      {
        id: 5,
        question: 'Is a search required for trademark registration?',
        answer: 'Not required, but highly recommended to avoid costly rejections and legal issues.'
      }
    ]
  },
  
  'amazon-brand-registry': {
    hero: {
      title: 'Amazon Brand Registry Services',
      description: 'Protect your brand on Amazon\'s marketplace with professional Brand Registry enrollment. Get access to powerful tools, enhanced content features, and proactive brand protection starting at just $99.',
      badge: 'Amazon Protection',
      image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/n93ttmtn_img-1.jpg'
    },
    process: [
      {
        step: 1,
        title: 'Verify Your Trademark',
        description: 'We verify that your trademark is registered and meets Amazon\'s eligibility requirements.'
      },
      {
        step: 2,
        title: 'Prepare Enrollment',
        description: 'Our team prepares all necessary documentation and information for your Brand Registry application.'
      },
      {
        step: 3,
        title: 'Complete Enrollment',
        description: 'We submit your enrollment, follow up with Amazon, and ensure successful registration.'
      }
    ],
    benefits: [
      {
        title: 'Brand Protection',
        description: 'Protect your intellectual property and prevent counterfeits on Amazon\'s marketplace.'
      },
      {
        title: 'Enhanced Content',
        description: 'Access A+ Content, Stores, and enhanced product detail pages to showcase your brand.'
      },
      {
        title: 'Powerful Tools',
        description: 'Get access to powerful search and reporting tools to find and report infringements.'
      },
      {
        title: 'Advertising Benefits',
        description: 'Unlock Sponsored Brands ads and other advertising features exclusive to brand owners.'
      },
      {
        title: 'Predictive Protection',
        description: 'Amazon\'s automated systems proactively detect and remove suspected infringing content.'
      },
      {
        title: 'Customer Trust',
        description: 'Build customer trust with verified brand status and professional product listings.'
      }
    ],
    pricing: [
      {
        id: 'standard',
        name: 'Standard',
        price: 99,
        popular: false,
        features: [
          { name: 'Amazon Brand Case Review', included: true },
          { name: 'Amazon Brand Case Filing', included: true },
          { name: '100% Satisfaction Guarantee', included: true },
          { name: 'Email Support', included: true }
        ]
      },
      {
        id: 'diamond',
        name: 'Diamond',
        price: 149,
        popular: true,
        features: [
          { name: 'Amazon Brand Case Review', included: true },
          { name: 'Amazon Brand Case Preparation', included: true },
          { name: 'Amazon Brand Case Filing', included: true },
          { name: '100% Satisfaction Guarantee', included: true },
          { name: 'Refusal Risk Meter', included: true },
          { name: 'Priority Processing', included: true },
          { name: 'Dedicated Support', included: true }
        ]
      },
      {
        id: 'premium',
        name: 'Premium',
        price: 199,
        popular: false,
        features: [
          { name: 'Amazon Brand Case Review', included: true },
          { name: 'Amazon Brand Case Preparation', included: true },
          { name: 'Amazon Brand Case Filing', included: true },
          { name: '100% Satisfaction Guarantee', included: true },
          { name: 'Refusal Risk Meter', included: true },
          { name: 'Amazon Brand Case Monitoring', included: true },
          { name: 'Complete Documentation', included: true },
          { name: 'Digital File', included: true },
          { name: 'Dedicated Case Manager', included: true },
          { name: 'Same-Day Filing', included: true }
        ]
      }
    ],
    keyBenefits: [
      'Trademark eligibility verification and guidance',
      'Complete enrollment application preparation',
      'Direct communication with Amazon on your behalf',
      'Fast processing with priority support options',
      'Post-enrollment guidance and support',
      '100% satisfaction guarantee on all services'
    ],
    faqs: [
      {
        id: 1,
        question: 'What is Amazon Brand Registry?',
        answer: 'A program that helps brand owners protect their intellectual property and create better customer experiences on Amazon.'
      },
      {
        id: 2,
        question: 'What do I need to enroll in Amazon Brand Registry?',
        answer: 'You need an active registered trademark and the ability to verify your brand relationship.'
      },
      {
        id: 3,
        question: 'How long does the enrollment process take?',
        answer: 'Most enrollments are completed within 3-5 business days after all requirements are met.'
      },
      {
        id: 4,
        question: 'Can I enroll with a pending trademark?',
        answer: 'Amazon typically requires a registered trademark, but some exceptions may apply in certain countries.'
      },
      {
        id: 5,
        question: 'What are the benefits of Brand Registry?',
        answer: 'Enhanced content, powerful reporting tools, brand protection, and access to exclusive advertising features.'
      }
    ]
  }
};
